import { CheckoutLifecycleEventPostMessageName } from '@eventbrite/checkout-postmessage-api';
import { Stage } from '@eventbrite/webapp-constants';

export { CheckoutLifecycleEventPostMessageName };

export type CheckoutLifecycleEventName = CheckoutLifecycleEventPostMessageName;

const LIFECYCLE_NAME_SET = new Set<string>(Object.values(CheckoutLifecycleEventPostMessageName) as string[]);

export function isCheckoutLifecycleEventName(value: string): value is CheckoutLifecycleEventName {
  return LIFECYCLE_NAME_SET.has(value);
}

const EVBQA_WIDGET_ORIGIN = 'https://www.evbqa.com';

export function getCheckoutMessageAllowedOrigins(serverUrl: string, stage: Stage): readonly string[] {
  const set = new Set<string>();
  try {
    set.add(new URL(serverUrl).origin);
  } catch {}
  if (stage === Stage.LOCAL || stage === Stage.TEST) {
    set.add(EVBQA_WIDGET_ORIGIN);
  }
  return Object.freeze(Array.from(set)) as readonly string[];
}

export function isTrustedCheckoutPostMessageOrigin(origin: string, allowedOrigins: readonly string[]): boolean {
  return allowedOrigins.includes(origin);
}

const EVENT_NAME_FIELDS = ['messageName', 'eventName', 'name', 'type'] as const;

function extractCandidateEventName(data: unknown): string | null {
  let candidate: string | null = null;
  if (typeof data === 'string') {
    candidate = data;
  } else if (data !== null && data !== undefined && typeof data === 'object') {
    const o = data as Record<string, unknown>;
    for (const field of EVENT_NAME_FIELDS) {
      const value = o[field];
      if (typeof value === 'string') {
        candidate = value;
        break;
      }
    }
  }
  return candidate;
}

export function parseCheckoutLifecycleEvent(data: unknown): CheckoutLifecycleEventName | null {
  const candidate = extractCandidateEventName(data);
  if (!candidate) {
    return null;
  }
  return isCheckoutLifecycleEventName(candidate) ? candidate : null;
}
